// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IApplyForPublicationRequest,
  TApplyForPublicationModel,
  IMappers,
  TApplyForPublicationResponse,
  IApplyForPublicationResponse,
  IApplyForPublicationResponseError,
} from './types';

export const defaultConfig: TApplyForPublicationModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'coworking',
  pathApi: '/v1/apply-for-publication/',
  requestType: 'json',
} as TApplyForPublicationModel;

export function createApplyForPublicationModel(parameters: IApplyForPublicationRequest): TApplyForPublicationModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IApplyForPublicationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IApplyForPublicationRequest;
}

export async function fetchApplyForPublication<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IApplyForPublicationOptions<TResponse200, TResponse400>): Promise<
  TApplyForPublicationResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createApplyForPublicationModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IApplyForPublicationResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IApplyForPublicationResponseError);
    }

  }
  return {
    statusCode,
    response,
    headers,
  } as TApplyForPublicationResponse;
}
